module.exports = __webpack_public_path__ + "0c530e48bfe615a04b2fe76b92def2f1.jpg";